import React, { useEffect } from 'react'
import { Loader2 } from 'lucide-react'

const OAuthCallback: React.FC = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    const error = urlParams.get('error')
    const state = urlParams.get('state')

    if (error) {
      // OAuth error
      if (window.opener) {
        window.opener.postMessage({
          type: 'GOOGLE_OAUTH_ERROR',
          error: error,
          description: urlParams.get('error_description') || 'OAuth authorization failed'
        }, window.location.origin)
      }
      window.close()
    } else if (code) {
      // OAuth success
      if (window.opener) {
        window.opener.postMessage({
          type: 'GOOGLE_OAUTH_SUCCESS',
          code: code,
          state: state
        }, window.location.origin)
      }
      window.close()
    } else {
      // No code or error - something went wrong
      if (window.opener) {
        window.opener.postMessage({
          type: 'GOOGLE_OAUTH_ERROR',
          error: 'no_code',
          description: 'No authorization code received'
        }, window.location.origin)
      }
      window.close()
    }
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto mb-4" />
        <h2 className="text-lg font-semibold text-gray-900">Processing Authorization...</h2>
        <p className="text-sm text-gray-600 mt-2">
          Please wait while we complete the authorization process.
        </p>
      </div>
    </div>
  )
}

export default OAuthCallback 